import { message } from "antd"
import { fetchApiUpload } from "../../app/lib/api"
import { actionLoading } from '../home/actions'

/////////////////////////////Upload One File////////////////////////////////////////////////
export const uploadOneFile = (payload) => async (dispatch, getState) => {
    try {
        dispatch(actionLoading(true))
        const response = await fetchApiUpload(
            `/app/other/upload-file`,
            "post",
            payload,
        )

        if (response.code === 400) {
            message.error(response?.message)
            setTimeout(() => {
                message.destroy()
            }, 2000);
            return;
        }
        // console.log("response", response);
        dispatch(actionLoading(false))
        return response?.data
    } catch (error) {
        alert(error || error?.message)
        console.log("uploadOneFileError", error)
    }
}

export const uploadWhiteList = (payload) => async () => {
    try {
        const response = await fetchApiUpload(
            `/api/uploadFile`,
            "post",
            payload,
        )
        if (response.code === 400) {
            message.error(response?.message)
            setTimeout(() => {
                message.destroy()
            }, 2000);
            return;
        }
        return response?.data?.filePaths?.file
    } catch (error) {
        alert(error || error?.message)
        console.log("uploadFileError", error)
    }
}

export const uploadMultiFile = (payload) => async () => {
    try {
        const response = await fetchApiUpload(
            `/api/uploadMultiImage`,
            "post",
            payload,
        )
        if (response.code === 400) {
            message.error(response?.message)
            setTimeout(() => {
                message.destroy()
            }, 2000);
            return;
        }
        return response?.data
    } catch (error) {
        alert(error || error?.message)
        console.log("uploadMultiFileError", error)
    }
}
/////////////////////////////End Upload One File////////////////////////////////////////////////
